








































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "AgenciesCompetitorReportGuide",
})
export default class AgenciesCompetitorReportGuide extends Vue {}
